export default {
  zoomIn: `
  <span
    class="
      @768/layout/border:3pt
      @768/layout/border:bottom:clear
      @768/layout/height:cap:3
      @768/layout/width:cap:3
      $color/background:white
      color/background
      layout/align:center
      layout/border:2pt
      layout/border:bottom:clear
      layout/flex
      layout/height:cap:2.5
      layout/justify:center
      layout/width:cap:2.5
    "
    style="pointer-events: auto">
    <svg class="typography/icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" stroke="#000" stroke-width="3">
      <path d="M2.5 8h11M8 2.5v11" fill="none" vector-effect="non-scaling-stroke" />
    </svg>
  </span>
  `,
  zoomOut: `
  <span
    id="zoom-out"
    class="
      @768/layout/border:3pt
      @768/layout/height:cap:3
      @768/layout/width:cap:3
      $color/background:white
      color/background
      layout/align:center
      layout/border:2pt
      layout/flex
      layout/height:cap:2.5
      layout/justify:center
      layout/width:cap:2.5
    "
    style="pointer-events: auto">
    <svg class="typography/icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" stroke="#000" stroke-width="3">
      <path d="M2.5 8h11" fill="none" vector-effect="non-scaling-stroke" />
    </svg>
  </span>
  `,
}